import {Component} from '@angular/core';

@Component({
    selector: 'qa-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: false
})
export class LoadingSpinnerComponent {

  constructor() { }

  // @Input() loading = false;

}
